export default __webpack_public_path__ + "mini-icon-android-13@2x.png";